//-- 
export var LeadChannel;
(function (LeadChannel) {
    LeadChannel[LeadChannel["EmailDesc"] = "Email"] = "EmailDesc";
    LeadChannel[LeadChannel["Email"] = 0] = "Email";
    LeadChannel[LeadChannel["CallMeBackDesc"] = "Call Me Back"] = "CallMeBackDesc";
    LeadChannel[LeadChannel["CallMeBack"] = 1] = "CallMeBack";
})(LeadChannel || (LeadChannel = {}));
export var LeadReason;
(function (LeadReason) {
    LeadReason[LeadReason["BuyingDesc"] = "Buying"] = "BuyingDesc";
    LeadReason[LeadReason["Buying"] = 0] = "Buying";
    LeadReason[LeadReason["SellingDesc"] = "Selling"] = "SellingDesc";
    LeadReason[LeadReason["Selling"] = 1] = "Selling";
    LeadReason[LeadReason["RentOutDesc"] = "Rent Out"] = "RentOutDesc";
    LeadReason[LeadReason["RentOut"] = 2] = "RentOut";
    LeadReason[LeadReason["FindToRentDesc"] = "Find To Rent"] = "FindToRentDesc";
    LeadReason[LeadReason["FindToRent"] = 3] = "FindToRent";
    LeadReason[LeadReason["OtherDesc"] = "Other"] = "OtherDesc";
    LeadReason[LeadReason["Other"] = 4] = "Other";
    LeadReason[LeadReason["SaleListingDesc"] = "Sale Listing"] = "SaleListingDesc";
    LeadReason[LeadReason["SaleListing"] = 10] = "SaleListing";
    LeadReason[LeadReason["RentalListingDesc"] = "Rental Listing"] = "RentalListingDesc";
    LeadReason[LeadReason["RentalListing"] = 11] = "RentalListing";
    LeadReason[LeadReason["DevelopmentDesc"] = "Development Enquiry"] = "DevelopmentDesc";
    LeadReason[LeadReason["Development"] = 20] = "Development";
})(LeadReason || (LeadReason = {}));
